module.exports = __webpack_public_path__ + "img/error-dark.6887b52f.svg";